enum NodeBehaviors {
    HONEST = 0,
    DISHONESTY_STEAL_MONEY = 1 << 1,
    DISHONESTY_REFUSE_SERVICE = 1 << 2,
}

export { NodeBehaviors }